import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mg-t-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_staff = _resolveComponent("info-staff")!
  const _component_advanceList = _resolveComponent("advanceList")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "container" }, {
    default: _withCtx(() => [
      _createVNode(_component_info_staff, { "card-id": _ctx.idCardNo }, null, 8, ["card-id"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_advanceList, { "card-id": _ctx.idCardNo }, null, 8, ["card-id"])
      ])
    ]),
    _: 1
  }))
}